import React, {useRef, useMemo} from 'react'
import PropTypes from 'prop-types'
import { Navigate } from 'react-big-calendar'
import EasyCalEvent from '../EasyCalEvent';
import { sort } from 'rrule/dist/esm/dateutil';

const DEFAULT_LENGTH = 30; // number of days in in range.

// const EasyCalAgenda = ({ event, localizer }) => {
const EasyCalAgenda = ({ //
  date,
  events,
  accessors,
  components,
  getters,
  onSelectEvent,
  onDoubleClickEvent,
  localizer,
  ...props
}) => {

  // Calculate range of dates to display 
  const range = useMemo(() => {
    const start = localizer.startOf(date, 'month');
    const end = localizer.add(start, DEFAULT_LENGTH, 'day');
    return localizer.range(start, end);
  }, [date, localizer]);

  // Filter events to include those within the range.
  const filteredEvents = useMemo(() => {
    return events.filter((event) => {
      const eventStart = accessors.start(event);
      const eventEnd   = accessors.end(event);
      return ( localizer.inRange(eventStart, range[0], range[range.length -1], 'date') );
    });
  }, [events, range, accessors, localizer]);

  const sortedEvents = useMemo(() => {
    return [...filteredEvents].sort((a, b) => +accessors.start(a) - +accessors.start(b));
  }, [filteredEvents, accessors]);

  const renderEventAgenda = (event) => {
    const {event: EasyCalEvent} = components;
    const title = accessors.title(event);
    const start = accessors.start(event);
    const end = accessors.end(event);
    const userProps = getters.eventProp(event, start, end, false);

    return (
      <div 
        key={event.id || title}  
        className='rbc-event-agenda easycal-agenda' 
        style={userProps.style}
        onClick={(e) => onSelectEvent && onSelectEvent(event, e)}
        onDoubleClick={(e) => onDoubleClickEvent && onDoubleClickEvent(event, e)}
      >
        {EasyCalEvent ? <EasyCalEvent event={event} title={title} view="agenda"/> : title}
      </div>
    );
  }

  return (
    <div className="rbc-event-agendas-view easycal-agendas-view">
      {sortedEvents.length > 0 ? (
        sortedEvents.map(renderEventAgenda)
        ) : (<div className='rbc-no-events easycal-noevents'>No events found.</div>
        )}
    </div>
  );
};

EasyCalAgenda.propTypes = {
  events: PropTypes.array.isRequired,
  accessors: PropTypes.object.isRequired,
  components: PropTypes.object.isRequired,
  date: PropTypes.instanceOf(Date),
  length: PropTypes.number.isRequired,
  localizer: PropTypes.object.isRequired,
  getters: PropTypes.object.isRequired,
  onSelectEvent: PropTypes.func,
  onDoubleClickEvent: PropTypes.func,
};

EasyCalAgenda.title = (start, { length = 30, localizer }) => {
  const end = localizer.add(start, length, 'day')
  return localizer.format({ start, end }, 'month')
}

EasyCalAgenda.range = (start, { length = 30, localizer }) => {
  const end = localizer.add(start, length, 'day')
  return { start, end }
}

EasyCalAgenda.navigate = (
  date,
  action,
  { length = 30, localizer }
) => {
  switch (action) {
    case Navigate.PREVIOUS:
      return localizer.add(date, -length, 'day')

    case Navigate.NEXT:
      return localizer.add(date, length, 'day')

    default:
      return date
  }
}

export default EasyCalAgenda;